import { component } from 'picoapp';

export default component(async (node) => {
  const currentTitle = node.querySelector<HTMLElement>('[data-current-title]');
  const linkedProducts = node.querySelectorAll<HTMLElement>('[data-linked-product]');

  const initCurrentTitle = () => {
    const { initialValue } = currentTitle.dataset;

    linkedProducts.forEach((linkedProduct) => {
      const { title } = linkedProduct.dataset;

      linkedProduct.addEventListener('mouseover', () => {
        currentTitle.textContent = title;
      });

      linkedProduct.addEventListener('mouseleave', () => {
        currentTitle.textContent = initialValue;
      });
    });
  };

  const init = () => {
    initCurrentTitle();
  };

  init();
});
